import { remoteAccessDialogReducerKey } from './RemoteAccessDialogConstants';

export function remoteAccessDialog(state) {
  return state.get(remoteAccessDialogReducerKey);
}

export function step(state) {
  return remoteAccessDialog(state).get('step');
}

export function departments(state) {
  return remoteAccessDialog(state).get('departments');
}

export function isLoading(state) {
  return remoteAccessDialog(state).get('isLoading');
}
